// src/components/ProtectedRoute/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { ROUTES } from '../../const/routes';
import styles from './ProtectedRoute.module.css';

const ProtectedRoute = ({ children }) => {
  const { userData, isLoading } = useUser();

  // Mientras se está verificando la sesión, mostrar pantalla de carga
  // NO redirigir hasta que termine la verificación
  if (isLoading) {
    return (
      <div
        className={
          'flex flex-col items-center justify-center min-h-screen ' +
          styles.loadingContainer
        }
      >
        <h2 className="text-4xl text-yellow-500 font-bold mb-2">Cargando...</h2>
      </div>
    );
  }

  // Ya terminó de cargar y no hay usuario → sesión inválida/expirada
  if (!userData) {
    return <Navigate to={ROUTES.login} replace />;
  }

  // Si está autenticado, renderizar el componente hijo
  return children;
};

export default ProtectedRoute;
